<template>
  <div>
    <table>
      <thead v-if="!isMobile">
        <th class='status'>
          <input type="checkbox" v-model="checkAll" @click="toggleAll" />
        </th>
        <th></th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'r.ID'}"
          @click="sort('r.ID')">
          ID
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'r.ID'"></i>
        </th>
        <th>STATUS</th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'cb.pickupTime'}"
          @click="sort('cb.pickupTime')">
          PICKUP TIME
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'cb.pickupTime'"></i>
        </th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'serviceTypeId'}"
          @click="sort('serviceTypeId')">
          SERVICE TYPE
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'serviceTypeId'"></i>
        </th>
        <th>SECTOR</th>
        <th>ADA</th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'cb.passengers'}"
          @click="sort('cb.passengers')">
          PAX
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'cb.passengers'"></i>
        </th>
        <th :class="{'sortable':true, 'active':currentOrder.field === 'cb.luggage'}"
          @click="sort('cb.luggage')">
          LUGGAGE
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'cb.luggage'"></i>
        </th>
        <!-- <th :class="{'sortable':true, 'active':currentOrder.field === 'p.inPool'}"
          @click="sort('p.inPool')">
          <span>IN POOL</span>
          <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
            v-show="currentOrder.field === 'p.inPool'"></i>
        </th> -->
      </thead>
      <tbody>
        <tnc-reservations-row v-for="(opPackage, index) in items" :opPackage="opPackage" :key="index" :isMobile="isMobile"></tnc-reservations-row>
      </tbody>
    </table>
  </div>
</template>

<script>
import ApiLaxitTncReservations from '@/modules/api/laxit/reservations'
import TncReservationsRow from './TncReservationsRow'

export default {
  name: 'tnc-reservations',
  components: { TncReservationsRow },
  props: ['isMobile'],
  data () {
    return {
      checkAll: false
    }
  },
  computed: {
    loading () { return this.$store.state.laxit.tncReservations.isLoading },
    currentOrder () {
      let laxit = this.$store.state.laxit.tncReservations
      return { field: laxit.order, asc: laxit.orderAsc }
    },
    items () { return this.$store.state.laxit.tncReservations.list },
    checkedPackages () { return this.$store.state.laxit.tncReservations.checked },
    inMap () {
      let self = this
      let mapItems = self.$store.state.laxit.dropzone.items
      let item = mapItems.filter(mapItem => mapItem.packageID === self.opPackage.id)
      return item.length > 0
    },
    isLastPage () {
      let tncReservations = this.$store.state.laxit.tncReservations
      return (tncReservations.currentPage * tncReservations.perPage) >= tncReservations.maxList
    }
  },
  methods: {
    getList () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('laxit/setTncReservationsIsLoading', true)
      ApiLaxitTncReservations.getPackages(self, res => {
        self.$store.commit('laxit/setTncReservationsIsLoading', false)
      })
    },
    sort (field) {
      if (this.loading) { return }
      let laxit = this.$store.state.laxit.tncReservations
      if (field !== laxit.order) {
        this.$store.commit('laxit/setTncReservationsOrderAsc', 1)
      } else {
        this.$store.commit('laxit/setTncReservationsOrderAsc', laxit.orderAsc === 1 ? 0 : 1)
      }
      this.$store.commit('laxit/setTncReservationsOrder', field)
      this.$store.commit('laxit/setTncReservationsCurrentPage', 1)
      this.$store.commit('laxit/resetTncReservationsList')
      this.getList()
    },
    loadMore () {
      if (this.isLastPage || this.loading) { return }
      this.$store.commit('laxit/setTncReservationsCurrentPage', this.$store.state.laxit.tncReservations.currentPage + 1)
      this.getList()
    },
    toggleAll () {
      let id = []
      if (!this.checkAll) {
        let tncReservations = this.$store.state.laxit.tncReservations
        tncReservations.list.forEach(item => {
          id.push(item.id)
        })
      }
      this.$store.commit('laxit/setTncReservationsChecked', id)
    }
  },
  watch: {
    checkedPackages (val) {
      this.checkAll = val.length === this.items.length
    }
  },
  mounted () {
    let self = this
    self.$store.commit('laxit/resetTncReservationsList')
    self.getList()
  }
}
</script>

<style lang="scss" scoped>
.table-loader{
  position: relative;
  width: 100%;
  margin: 50px auto;
  text-align: center;

  & .loader-title{
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .loader-text{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    border-right: none;
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  input{
    display: inline-block;
    width: auto;
  }
  .type{
    display: inline-block;
    padding: 3px 6px;
    text-transform: uppercase;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;

    &.tnc{ background: #2ab77c; }
    &.tcp{ background: #3f81a0; }
    &.psc{ background: #de6c2a; }
  }
  .status{ text-transform: capitalize; }
  .expired{ color: #de2929; }
  .fa-check-circle{ color: #0fda4e; }
  .fa-times-circle{ color: #ef3535; }
  a{ cursor: pointer; }
  .date{ word-spacing: 5px; }
}
</style>



// WEBPACK FOOTER //
// src/components/Laxit/TncReservations.vue